<div class="tab-navigation">
  <button
    *ngFor="let tab of tabs"
    class="tab-button"
    [class.active]="isTabActive(tab.id)"
    [class.disabled]="isTabDisabled(tab.id)"
    [disabled]="isTabDisabled(tab.id)"
    (click)="setActiveTab(tab.id)"
  >
    <i class="material-icons" *ngIf="tab.icon">{{ tab.icon }}</i>
    {{ tab.label }}
  </button>
</div>
